module.exports = "/lucky-balls/img/color_betting/blue.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/color_betting/blue.png
// module id = 977
// module chunks = 0